import styled from 'styled-components/macro';
import { mediaQuery } from '../../styles/utils';

export const LogoContainer = styled.div({
  maxWidth: '960px',
  margin: '0 auto',
});

export const Logo = styled.img({
  width: '131px',

  [mediaQuery('tablet')]: {
    width: '263px',
  },
});

export const StepTimeline = styled.div({
  position: 'relative',
  minHeight: '50px',
  marginBottom: '15px',
  ':before': {
    content: "' '",
    left: 0,
    position: 'absolute',
    background: '#e4e1dc',
    height: '4px',
    width: '100%',
    top: '19px',
    zIndex: 99,
  },
});

export const StepsContainer = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  maxWidth: '960px',
  margin: '0 auto',
});

export const StepContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  margin: '0 auto',
  fontSize: '12px',
  width: '70px',
  textAlign: 'center',

  [mediaQuery('tablet')]: {
    fontSize: '16px',
  },
});

export const StepCircle = styled.div(
  {
    zIndex: 999,
    width: '34px',
    height: '34px',
    borderRadius: '50%',
    border: '2px solid #e4e1dc',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '5px',
    fontSize: '16px',

    [mediaQuery('tablet')]: {
      width: '42px',
      height: '42px',
    },
  },
  ({ filled }) => ({
    backgroundColor: filled ? '#e4e1dc' : '#FFF',
  })
);
